<template>
  <v-select
    :rules="[rules.required]"
    :modelValue="modelValue"
    :items="aiModels"
    item-title="name"
    item-value="version"
    label="Select AI model"
    hide-no-data
    hide-details
    density="compact"
    variant="outlined"
    style="min-width: 190px"
    @update:model-value="saveAiVersion"
    :disabled="$store.state.isWorkflowDisabled"
    :menu-props="{ maxHeight: 500, location: 'bottom' }"
  />
</template>

<script>
import workflowApi from '@/api/workflowApi'
import { mapState } from 'vuex'

export default {
  name: 'AiVersionSelector',
  props: {
    modelValue: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      aiModels: [
        { name: 'OpenAI GPT-6 Luna', version: 5 },
        { name: 'OpenAI GPT-5.6 Terra', version: 6 },
        { name: 'OpenAI GPT-6 Sol', version: 7 },
        { name: 'Gemini 3.8 Flash', version: 11 },
        { name: 'Gemini 3.1 Pro', version: 12 },
        { name: 'Claude Sonnet 5', version: 15 },
        { name: 'Claude Opus 5.5', version: 16 },
        { name: 'Claude Fable 5', version: 17 },
        { name: 'Kimi K2.5', version: 20 },
        { name: 'Qwen3 VL', version: 21 }
      ],
      rules: {
        required: value => !!value || 'Required.'
      }
    }
  },
  computed: {
    ...mapState({
      workflow: state => state.workflow.workflow
    })
  },
  methods: {
    async saveAiVersion (newVal) {
      this.$emit('update:modelValue', newVal)
      await workflowApi.updateWorkflowNoHistoryMutation(
        this.$route.params.projectId,
        {
          id: this.$route.params.id,
          expectedVersion: this.workflow.version,
          aiVersion: newVal
        }
      )
    }
  },
  watch: {
    workflow: {
      handler (newVal) {
        this.$emit('update:modelValue', newVal.aiVersion || 11)
      },
      deep: true,
      immediate: true
    }
  }
}

</script>
